// extracted by mini-css-extract-plugin
export default {"header":"totp-setup_header__8FFaf","setupDetails":"totp-setup_setupDetails__LEYPZ","qrCode":"totp-setup_qrCode__+2M9e"};